import { Component, inject, type OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { Store } from '@ngrx/store';

import { LocationActions } from '../../ngrx-store';

@Component({
  imports: [
    MatDialogModule,
    MatFormField,
    MatIconButton,
    MatInput,
    MatSuffix,
    ReactiveFormsModule,
    FormsModule,
  ],
  selector: 'avs-mobile-edit-external-link-modal',
  templateUrl: './add-external-link-modal.component.html',
})
export class AddExternalLinkModalComponent implements OnInit {
  inputValue = '';

  private data = inject<{
    link: string;
    locationId: string;
    spaceId: string;
  }>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<AddExternalLinkModalComponent>>(MatDialogRef);
  private store = inject(Store);

  clear() {
    this.inputValue = '';
  }

  confirm() {
    this.store.dispatch(
      LocationActions.updateRoom({
        data: { externalReference: this.inputValue },
        locationId: this.data.locationId,
        spaceId: this.data.spaceId,
      }),
    );
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.inputValue = this.data?.link || '';
  }
}
